import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components'
import now_icon from '../../asset/icon/now.png';
import { NavItem } from './AdminLeftNavBar';


export interface BigMenuProps {
  isHovered: boolean;
  data: NavItem;
}

const AdminBigMenu: React.FC<BigMenuProps> = ({ isHovered, data }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const checkIsThisPage = () => {
    return pathname === data.path;
  }
  const isThisPage = checkIsThisPage();

  const handleMenuClick = () => {
    navigate(data.path);
  }

  return (
    <>
      <BigMenuComp $isHovered={isHovered} $isVisible={data.isVisible} onClick={handleMenuClick}>
        <NowIconButton $isActive={isThisPage} $backgroundImg={now_icon} />
        <StyledLink $isActive={isThisPage}>
          {data.label}
        </StyledLink>
      </BigMenuComp>
    </>
  )
}

const BigMenuComp = styled.div<{ $isHovered: boolean, $isVisible: boolean }>`
  width: ${({ $isHovered }) => $isHovered ? 'clamp(150px, 20vw, 210px)' : '0vw'};
  height: 28px;
  display: flex;
  align-items: center;
  padding: 4px clamp(12px, 1.2vw, 1.2vw);
  overflow: hidden;
  transition: width 0.6s ease-in-out;
  color: ${({ theme }) => theme.colors.color_Gray_01};
  opacity: ${({ $isVisible }) => $isVisible ? 1 : 0.3};
  cursor: pointer;
`;

const StyledLink = styled.div<{ $isActive: boolean; }>`
  text-decoration: ${({ $isActive }) => $isActive ? 'underline' : 'none'};
  &:hover {
    text-decoration: ${({ theme }) => theme.fontWeight.decoration};
  }
  cursor: pointer;
  ${({ theme }) => theme.typography.Body_04};
`;

const NowIconButton = styled.div<{ $backgroundImg: string, $isActive: boolean }>`
  width: 6px;
  height: 6px;
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  opacity: ${({ $isActive }) => $isActive ? 1 : 0};
  transition: all 0.3s;
  margin-right: 4px;
`;

export default AdminBigMenu;
